import React from "react";

const INDIA_DIAL_CODE = "+91";
const INDIA_FLAG_LABEL = "🇮🇳 +91";
const INDIA_PHONE_TYPES = new Set(["mobile", "whatsapp", "parent_mobile"]);

export function isIndianPhoneContactType(type) {
  return INDIA_PHONE_TYPES.has(String(type || "").trim().toLowerCase());
}

export function extractIndianPhoneDigits(value) {
  const digits = String(value || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.length === 12 && digits.startsWith("91")) return digits.slice(2);
  if (digits.length === 11 && digits.startsWith("0")) return digits.slice(1);
  if (digits.length <= 10) return digits;
  return digits;
}

export function getIndianPhoneInputValue(value) {
  return extractIndianPhoneDigits(value).slice(0, 10);
}

export function isValidIndianPhoneDigits(value) {
  return /^[6-9]\d{9}$/.test(String(value || ""));
}

export function validateIndianPhoneValue(value) {
  const digits = extractIndianPhoneDigits(value);
  if (!digits) return "";
  return isValidIndianPhoneDigits(digits) ? "" : "Enter a valid 10-digit Indian mobile number.";
}

export function normalizeIndianPhone(value) {
  const digits = extractIndianPhoneDigits(value);
  return isValidIndianPhoneDigits(digits) ? `91${digits}` : String(value || "").replace(/\D/g, "");
}

export function formatIndianPhoneDisplay(value) {
  const digits = extractIndianPhoneDigits(value);
  return isValidIndianPhoneDigits(digits) ? `${INDIA_DIAL_CODE} ${digits}` : String(value || "").trim();
}

export function toStoredIndianPhoneValue(value) {
  const digits = extractIndianPhoneDigits(value);
  return isValidIndianPhoneDigits(digits) ? formatIndianPhoneDisplay(digits) : String(value || "").trim();
}

export function getContactDisplayValue(contact) {
  const type = String(contact?.contact_type || contact?.type || "").trim().toLowerCase();
  const value = contact?.contact_value || "";
  return isIndianPhoneContactType(type) ? formatIndianPhoneDisplay(value) : String(value || "").trim();
}

export function getContactValueFieldLabel(type) {
  const normalized = String(type || "").trim().toLowerCase();
  if (normalized === "email") return "Email";
  if (normalized === "whatsapp") return "WhatsApp Number";
  if (normalized === "parent_mobile") return "Parent Mobile Number";
  if (normalized === "mobile") return "Phone Number";
  if (normalized === "other") return "Other Contact";
  return "Value";
}

export function IndianPhoneInput({
  value,
  onChange,
  inputStyle,
  selectStyle,
  wrapperStyle,
  selectWrapStyle,
  placeholder = "9876543210",
}) {
  const digits = getIndianPhoneInputValue(value);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "120px 1fr",
        gap: 12,
        alignItems: "stretch",
        ...wrapperStyle,
      }}
    >
      <div style={{ position: "relative", ...selectWrapStyle }}>
        <select
          value={INDIA_DIAL_CODE}
          disabled
          style={{
            width: "100%",
            cursor: "default",
            opacity: 1,
            ...selectStyle,
          }}
        >
          <option value={INDIA_DIAL_CODE}>{INDIA_FLAG_LABEL}</option>
        </select>
      </div>

      <input
        type="tel"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={10}
        value={digits}
        placeholder={placeholder}
        style={inputStyle}
        onChange={(event) => {
          onChange(String(event.target.value || "").replace(/\D/g, "").slice(0, 10));
        }}
      />
    </div>
  );
}
